import React, { Component } from 'react';
import logo from '../img/logo_cfi.png';
import logo_proviso from '../img/cfi_logo_proviso_home.svg';
import { login } from '../api/UserFunctions';
import '../css/Login.css';
import '../css/responsive.css';
import Auth from '../auth/Auth';
import { connect } from "react-redux";
import { changeProfile, changeCommande, changeDevis, changeAuth} from "../actions/index";

function mapDispatchToProps(dispatch) {
    return {
      changeProfile:profile_user => dispatch(changeProfile(profile_user)),
      changeCommande:commande_user => dispatch(changeCommande(commande_user)),
      changeDevis:devis_user => dispatch(changeDevis(devis_user)),
      changeAuth:auth => dispatch(changeAuth(auth))
    };
}

class Connected_login extends Component {
  _isMounted = false;

  constructor(props){
    super(props);
    this.state = {
      email: '',
      password: '',
      ok:0,
      style_forget:{display:"none"},
      style_incorrect:{display:"none"},
      style_incorrect2:{display:"none"},
      style_incorrect3:{display:"none"},
      page:false,
      errors: {}
    }


    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleConnexion=this.handleConnexion.bind(this);
    this.logout=this.logout.bind(this);
  }


  componentDidMount() {
    this._isMounted = true;
  }

   componentWillUnmount() {
    this._isMounted = false;
  }

  handleForget(){
    this.setState({style_forget:{display:"block"}});
    this.setState({page:true});
  }
  handlePage(event){
    const target = event.target;
    if (target.id !== 'modal') {
    return ;
    }
    this.setState({style_forget:{display:"none"}});
    this.setState({page:false});
  }

  handleConnexion(){
    
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  onSubmit(e) {
    this.setState({essai:true});
    e.preventDefault();
    const user = {
      email: this.state.email,
      password: this.state.password,
      ok:this.state.ok
    }
    
    login(user).then(res => {

      this._isMounted = true;

      if (res) {
        localStorage.setItem('user',true);
        window.location.href = process.env.REACT_APP_ID_PROVISO+"/proviso_user";
      }
      else{

        if(user.ok === 400){
          this.setState({style_incorrect:{display:"block"}});
          this.setState({style_incorrect3:{display:"none"}});
          this.setState({style_incorrect2:{display:"none"}});

        }
        if(user.ok === 401){
          this.setState({style_incorrect2:{display:"block"}});
          this.setState({style_incorrect:{display:"none"}});
          this.setState({style_incorrect3:{display:"none"}});

        }
        if(user.ok === 429){
          this.setState({style_incorrect3:{display:"block"}});
          this.setState({style_incorrect:{display:"none"}});
          this.setState({style_incorrect2:{display:"none"}});

        }
      }
      

    })





  }


  login(){
  Auth.authenticate();
  }
  logout(){
  Auth.signout();
  }

  updateState() {
        this.setState({ error_msg: true });
    }


  render() {

    if(this.state.page){

      

      return (
        <div id="page_connexion" onClick={(event) => this.handlePage(event)}> 
          <div id="design1">
            <div id="decor">
              <div><img id="logo_cfi" src={logo} alt="logo de CFI"/></div>
              <img id="logo_proviso" src={logo_proviso} alt="logo de Proviso"/>
              <p id="texte_accueil">Plateforme de suivi de commandes<br/> solutions et services</p>
            </div>
          </div>
          <div id="connexion">
            <div id="formulaire">
              <div id="titre">
                <h3>Identifiant</h3>
              </div>
              <form className="form_connexion" onSubmit={this.onSubmit}>
                <input
                  id="form_email"
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={this.state.email}
                  onChange={this.onChange}
                  />
                <br/>
                <input
                  id="form_mdp"
                  type="password"
                  placeholder="Mot de passe"
                  name="password"
                  value={this.state.password}
                  onChange={this.onChange}
                />
                <br/>
                <div id="this_button">
                   <button id="form_button" type="submit" onClick={(event) => this.redirectToHome}>SE CONNECTER</button>
                  <p id="link_mdp" /*onClick={(event) => this.handleForget()}*/>Mot de passe oublié</p>
                  <p id="incorrect" style={this.state.style_incorrect}>Email incorrect</p>
                  <p id="incorrect2" style={this.state.style_incorrect2}>Mot de passe incorrect</p>
                  <p id="incorrect3" style={this.state.style_incorrect3}>Trop de tentatives, veuillez réessayer dans 5 minutes</p>
                </div>
              </form>
            </div>
          </div>
          <div id="modal" style={this.state.style_forget} >
        
            <div className="modal-content" >
              <p id="forget_title">Récupération de votre mot de passe</p>
              <form className="form_connexion">
                <input
                  id="form_email_forget"
                  type="email"
                  placeholder="Email"
                  name="email"
                  />
                <br/>
                <input
                  id="form_mdp_forget"
                  type="text"
                  placeholder="N° de compte client"
                  name="password"
                />
                <br/>
                <div id="this_button">
                   <button id="form_button_forget" type="submit">Envoyer</button>
                </div>
              </form>
              <p id="advice_forget">Vous devez saisir votre adresse email professionnelle et le N° de contrat qui commance par CXX suivis d'une série de chiffres</p>
            </div>
          </div>
        </div>


        );
    
    }
    else{
      return (

        <div id="page_connexion" onClick={(event) => this.handlePage(event)}>
          <div id="design1">
            <div id="decor">
              <div><img id="logo_cfi" src={logo} alt="logo de CFI"/></div>
              <img id="logo_proviso" src={logo_proviso} alt="logo de Proviso"/>
              <p id="texte_accueil">Plateforme de suivi de commandes<br/> solutions et services</p>
            </div>
          </div>
          <div id="connexion">
            <div id="formulaire">
              <div id="titre">
                <h3>Identifiant</h3>
              </div>
              <form className="form_connexion" onSubmit={this.onSubmit}>
                <input
                  id="form_email"
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={this.state.email}
                  onChange={this.onChange}
                  />
                <br/>
                <input
                  id="form_mdp"
                  type="password"
                  placeholder="Mot de passe"
                  name="password"
                  value={this.state.password}
                  onChange={this.onChange}
                />
                <br/>
                <div id="this_button">
                <button id="form_button" type="submit" >SE CONNECTER</button>
                <p id="link_mdp" /*onClick={(event) => this.handleForget()}*/>Mot de passe oublié</p>
                <p id="incorrect" style={this.state.style_incorrect}>Email incorrect</p>
                <p id="incorrect2" style={this.state.style_incorrect2}>Mot de passe incorrect</p>
                <p id="incorrect3" style={this.state.style_incorrect3}>Trop de tentatives, veuillez réessayer dans 5 minutes</p>
                </div>
              </form>
            </div>
          </div>
          <div id="myModal" className="modal" style={this.state.style_forget}>
        
            <div className="modal-content" >
              <p id="forget_title">Récupération de votre mot de passe</p>
              <form className="form_connexion" >
                <input
                  id="form_email_forget"
                  type="email"
                  placeholder="Email"
                  name="email"
                  />
                <br/>
                <input
                  id="form_mdp_forget"
                  type="text"
                  placeholder="N° de compte client"
                  name="password"
                />
                <br/>
                <div id="this_button">
                   <button id="form_button_forget" type="submit">Envoyer</button>
                </div>
              </form>
              <p id="advice_forget">Vous devez saisir votre adresse email professionnelle et le N° de contrat qui commance par CXX suivis d'une série de chiffres</p>
            </div>
          </div>
        </div>


        );
    }
    
    }
  }
const Login = connect(
  null,
  mapDispatchToProps
)(Connected_login);

export default Login;
